import React from "react";
import PropTypes from "prop-types";
import styles from "../../styles/shared-module-css/reuseableTable.module.css";

const ReusableTable = ({
  headers,
  rows,
  showAction = false, // Default to false
  onRowAction,
  actionIcon: ActionIcon,
}) => {
  return (
    <div className={styles.table_container}>
      <table className={styles.table}>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
            {showAction && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((row, rowIndex) => (
              <tr key={row.id || rowIndex}>
                {headers.map((header, colIndex) => (
                  <td key={colIndex}>{row[header.toLowerCase()] || "_ _"}</td>
                ))}
                {showAction && (
                  <td>
                    <button
                      onClick={() => onRowAction?.(row)} // Optional chaining to ensure no error if onRowAction is undefined
                      className={styles.delete_btn}
                    >
                      {ActionIcon ? (
                        <ActionIcon className={styles.del_icon} />
                      ) : (
                        "Action"
                      )}
                    </button>
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headers.length + (showAction ? 1 : 0)}>
                No data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

ReusableTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  showAction: PropTypes.bool, // New prop for controlling action column
  onRowAction: PropTypes.func,
  actionIcon: PropTypes.elementType,
};

export default ReusableTable;
